import React from 'react';
import { MathMLRendererProps } from '../../types/index';

export const MathMLRenderer: React.FC<MathMLRendererProps> = ({ 
  mathML, 
  className, 
  style 
}) => {
  const defaultStyle: React.CSSProperties = {
    fontSize: '14px',
    lineHeight: '1.4',
    ...style
  };

  return (
    <div 
      className={className} 
      style={defaultStyle}
      dangerouslySetInnerHTML={{ __html: mathML }}
    />
  );
};

// Helper function to create MathML strings more easily
export const createMathML = (content: string, display: 'block' | 'inline' = 'block'): string => {
  const mathStyle = display === 'inline' ? 'font-size: 14px;' : 'font-size: 16px;';
  return `<math display="${display}" xmlns="http://www.w3.org/1998/Math/MathML" style="${mathStyle}">${content}</math>`;
};